import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installUpdateManager } from "@/updateManager";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register SW + detect new deployments → surfaces `cs:update-available` event
// which <UpdateAvailableToast> listens to.
installUpdateManager();
